<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" ref="form" label-width="110px">
        <div class="input-box" v-show="!out">
          <div>
            <label style="margin:5px 10px 0 20px;">地区：</label>
          </div>
          <div style="margin-bottom:15px">  
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div>
            <el-form-item   label="申请开始时间：">
              <el-date-picker
                style="width:193px;"
                value-format="timestamp"
                v-model="form.startApplyTime"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item   label="申请结束时间：">
              <el-date-picker
                style="width:193px;"
                value-format="timestamp"
                v-model="form.endApplyTime"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:api,data:form,callback:_d => tableData = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
        <div class="input-box" v-show="out">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area   :value="area_data"
                :diss="dis"
                :arr="arrPlace2"
                @getPlace="getPlace2"/>
          </div>
          <div>
            <el-form-item label="处理开始时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.startTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="处理结束时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.endTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:`${api}/report`,data:form1,callback:_d => tableData1 = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit" v-show="!out">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('ycxqzcybttbj')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._c"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/一次性求职创业补贴统计表--导入.xls" download="一次性求职创业补贴统计表.xls">下载模板</a> -->
        下载模板
      </el-button>
    </div>
    <el-button v-if="showBtn[5].isShow" type="primary" @click="out = !out" icon="el-icon-document-remove">{{out===false?'导出报表':'数据采集'}}</el-button>
    <div class="edit" v-show="out">
      <el-button type="primary" v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table" v-show="!out">
      <el-table
        :data="tableData"
        border
        max-height="550"
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <div class="table" v-show="out">
      <el-table
        :data="tableData1"
        border
        max-height="550"
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo1"
          :key="index"
          :prop="item.key"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="一次性求职创业补贴统计表"
      :visible.sync="centerDialogVisible"
      @close="close"
      :modal="false"
      width="1400px"
      :close-on-click-modal="false"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" size="mini" :rules="rules" ref="editForm" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item prop="idCard" label="身份证号：">
                          <el-input style="width:193px;" v-model="editForm.idCard"></el-input>
                        </el-form-item>
                        <el-form-item prop="phone" label="联系方式：">
                          <el-input style="width:193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                        <el-form-item prop="name" label="申请人姓名：">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="申请金额(元)：">
                          <el-input style="width:193px;" v-model="editForm.applyFee"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="申请时间：">
                          <el-date-picker
                            style="width:193px;"
                            value-format="yyyy-MM-dd"
                            v-model="editForm.time"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="申报地区：">
                          <el-input style="width:193px;" v-model="editForm.area"></el-input>
                        </el-form-item>
                        <el-form-item label="审核日期：">
                          <el-date-picker
                            style="width:193px;"
                            value-format="yyyy-MM-dd"
                            v-model="editForm.auditTime"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="审核人：">
                          <el-input style="width:193px;" v-model="editForm.auditUser"></el-input>
                        </el-form-item>
                        <el-form-item label="审核通过金额(元)：">
                          <el-input style="width:193px;" v-model="editForm.applyOkFee"></el-input>
                        </el-form-item>
                        <el-form-item label="审核驳回金额(元)：">
                          <el-input style="width:193px;" v-model="editForm.applyFaildFee"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>

<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      form:{},
      type:'1',
      api:'/user/onceSetupAllowance',
      centerDialogVisible:false,
      tableData:[],
      tableData1:[],
      selectRow:[],
      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key: 'name', value: '申请人姓名'},
        {key: 'idCard', value: '身份证'},
        {key: 'phone', value: '联系方式'},
        {key: 'applyFee', value: '申请金额'},
        {key: 'time', value: '申请日期'},
        {key: 'area', value: '申报地区'},
        {key: 'auditUser', value: '审核人'},
        {key: 'applyOkFee', value: '审核通过金额'},
        {key: 'applyFaildFee', value: '审核驳回金额'},
        {key: 'auditTime', value: '审核日期'},
      ],  						

      baseInfo1:[
        {key: 'areaName', value: '行政区划名称'},
        {key: 'totalCount', value: '申请人数'},
        {key: 'applyFee', value: '申请金额'},
        {key: 'passCount', value: '审核通过人数'},
        {key: 'passFee', value: '审核通过金额'},
        {key: 'failedCount', value: '审核驳回人数'},
        {key: 'failedFee', value: '审核驳回金额'},
      ],         
      rules:{
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 18, max: 18, message: '长度为18个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
      },
      isCreate:false,
      out:false,
    }
  },
  created() {
    this.isShowBtn("OnceSetupAllowance")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.time = new Date(newForm.time).getTime()
      newForm.auditTime = new Date(newForm.auditTime).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
    //查询列表
    getData() {
      this.$api.getData(this.api,{idCard:'123456789987654321'})
      .then(res =>{
        if (res.data.status === 0) {
          this.tableData = JSON.parse(res.data.data)
          this.total = res.data.size
        } else {
          this._status(res.data)
        }
      })
    }
  }
}
</script>

<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}

</style>